import React, { Component } from 'react';
import Img from '../../assets/Product/recogimg.JPG';
import './RecognizedBy.css';

export default class RecognizedBy extends Component {
    render() {
        return (
            <div className="recognized">
                <div className="heading">Recognized <span className="con">By</span></div>
                <div className="row">
                    <div className="col-xs-10 col-sm-12 col-md-6 col-lg-3 recogimg">
                        <img className="recongImg" alt="company" src={Img} />
                    </div>
                    <div className="col-xs-10 col-sm-12 col-md-6 col-lg-3 recogimg">
                        <img className="recongImg" alt="company" src={Img} />
                    </div>
                    <div className="col-xs-10 col-sm-12 col-md-6 col-lg-3 recogimg">
                        <img className="recongImg" alt="company" src={Img} />
                    </div>
                    <div className="col-xs-10 col-sm-12 col-md-6 col-lg-3 recogimg">
                        <img className="recongImg" alt="company" src={Img} />
                    </div>
                </div>
            </div>
        )
    }
}